'use strict';

export default class ResultCommonController 
{
	/*@ngInject*/
	constructor($state, $stateParams, $log, $http, $location, $translate)
	{
		//console.log("Common controller: Aqui hago la peticion de los datos del evento para cargar la cabecera");
		//console.log($stateParams); // Aqui solo tengo EVENT

		this.$state = $state;
		this.$location = $location;
		this.$translate = $translate;
		this.stateParams = $stateParams;

		this.treeOptions = {
			nodeChildren: "children",
			dirSelectable: true,
			allowDeselect: false,
			/*equality: function(node1, node2) {
				return node1.path === node2.path;
			},*/
			injectClasses: {
				ul: "a1",
				li: "a2",
				liSelected: "a7 invertcolor",
				iExpanded: "a3 fa fa-minus-square-o",
				iCollapsed: "a4 fa fa-plus-square-o",
				iLeaf: "a5 fa fa-circle-thin",
				label: "a6",
				labelSelected: "a8"
			}
		};
		
		$http.post("/api/frontend/results/" + $stateParams.event)
		.then(response => 
		{
			this.event = response.data;
			
			if (this.redirectToFirstRace === true)
			{
				this.redirectToFirstRace = undefined;
				if (!this.event.races || this.event.races.length === 0) return;
				this.$state.go("CommonResults.Summary", {race: this.event.races[0].id});
			}
			else if (this.deferChangeRace === true)
			{
				this.deferChangeRace = undefined;
				this.ChangeRace();
			}
		});
	}

	TreeHandler(path) 
	{
		if (!this.event) return;
		this.$location.path("/res/" + this.event.id + "/" + path);
	}

	FindNode(node, path)
	{
		if (node.path === path)
		{
			//if (node.children)
			{
				let x = {};
				x.node = node;
				x.name = null; // Se controla en la vista para hacer la traducción correctamente
				this.nodesPath.push(x);
			}
			return true;
		}
		else
		{
			if (node.children)
			{
				for (let i of node.children) 
				{
					if (this.FindNode(i, path) === true)
					{
						let x = {};
						x.node = node;
						x.name = i.name;
						this.nodesPath.splice(0, 0, x);
						return true;
					}
				}
			}
		}

		return false;
	}

	ComposePath()
	{
		let path = "";
		//if (this.stateParams.event) path = this.stateParams.event; else return path;
		if (this.stateParams.race) path = this.stateParams.race; else return path;
		if (this.stateParams.session) path += "/" + this.stateParams.session; else return path;
		if (this.stateParams.round) path += "/" + this.stateParams.round; else return path;
		if (this.stateParams.serie) path += "/" + this.stateParams.serie;

		return path;
	}

	ChangeRace()
	{
		if (this.event.races == null) return;
		
		let oldRace = this.selectedRaceId;
		let race = this.stateParams.race;
		this.selectedRaceId = race;
		
		let r = _.find(this.event.races, function(x) { return x.id === race; });
		if (r)
		{
			var selectedRace = r;
			this.selectedRaceIndex = this.event.races.indexOf(r);
		}
		else
		{
			var selectedRace = this.event.races[0].id;
			this.selectedRaceIndex = 0;
		}

		if (!selectedRace.children || selectedRace.children.length === 0)
		{
			this.tree = {children:[]};
			this.nodesPath = [];
			return;
		}

		if (oldRace !== this.selectedRaceId)
		{
			// Clonar desde el nodo de carrera, porque luego insertaremos el nodo de "SUMMARY"
			this.tree = selectedRace.children.slice(0);
			this.ExpandNodes();

			// Insertar el nodo de SUMMARY
			let summary = {
				name: null, // Se controla en la vista para hacer la traducción correctamente
				path: this.stateParams.race
			};
			this.tree.splice(0, 0, summary);
		}

		let path = this.ComposePath();

		this.nodesPath = [];
		this.FindNode(selectedRace, path);

		if (this.nodesPath.length >= 2)
		{
			// Seleccionar el nodo actual
			this.selectedTreeNode = this.nodesPath[this.nodesPath.length - 1].node;

			// Expandir el padre
			let selectedParent = this.nodesPath[this.nodesPath.length - 2].node;
			if (this.expanded.indexOf(selectedParent) === -1)
				this.expanded.push(selectedParent);
		}
		else if (this.nodesPath.length == 1)
		{
			// Como el nodo de Summary se inserta a pelo, no corresponde con el objeto "race" y hay que seleccionarlo manualmente
			this.selectedTreeNode = this.tree[0];
		}
	}

	ExpandNodes()
	{
		var allNodes = [];

		var AddToAllNodes = function(children)
		{
			if (!children || typeof (children) == "array" && children.length == 0) 
				return;

			for (var i = 0; i < children.length; i++) 
			{
				allNodes.push(children[i]);
				AddToAllNodes(children[i]);
			}
		}

		AddToAllNodes(this.tree);
		this.expanded = allNodes;
	}

	RedirectToFirstRace()
	{
		if (this.event)
			this.$state.go("CommonResults.Summary", {race: this.event.races[0].id});
		else
			this.redirectToFirstRace = true;
	}
	
	SelectNodeFromStateParams(params)
	{
		this.stateParams = params;
		if (!this.event)
			this.deferChangeRace = true;
		else
			this.ChangeRace();
	}
}



// WEBPACK FOOTER //
// ./client/app/frontend/results/result_common.controller.js